/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Method
 */
export type GetAuthHistoryResponseMethod = typeof GetAuthHistoryResponseMethod[keyof typeof GetAuthHistoryResponseMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuthHistoryResponseMethod = {
  'loginauth0-google': 'login:auth0-google',
  'loginauth0-apple': 'login:auth0-apple',
  'loginauth0-local': 'login:auth0-local',
  loginlocal: 'login:local',
  loginauth0: 'login:auth0',
  loginjwt: 'login:jwt',
  'loginjwt-refresh': 'login:jwt-refresh',
  'loginjwt-mobile-refresh': 'login:jwt-mobile-refresh',
  'loginadmin-access': 'login:admin-access',
  'loginswitch-account': 'login:switch-account',
} as const;
